import { render } from "./ItemPriceList.vue?vue&type=template&id=b68841be"
import script from "./ItemPriceList.vue?vue&type=script&lang=js"
export * from "./ItemPriceList.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__